module.exports = __webpack_public_path__ + "img/Weapon_230.696f2540.png";